export default {
  all: [],
  one: {},
  lastEvaluatedKey: null,
  loadAll: false,
};
